/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { getLoginUser } from './loginService';
import { isCallcenterLoggedIn, getCallcenterUser } from './callcenterService';

// Tag catalog CRUD lives in jobs.php (the tags catalog is shared across entities).
const baseUrl = `${process.env.BACKEND_API_BASE_URL}/jobs.php`;

const getToken = () => (isCallcenterLoggedIn() ? getCallcenterUser() : getLoginUser()).token;

export const tagsService = {
  // Company tag catalog: [{ id, name }]
  get_tags: async data =>
    axios.get(baseUrl, {
      params: {
        method: 'get_tags',
        token: getToken(),
        ...data, // { dbname }
      },
    }),
  // Create (id=0) or rename (id>0) a tag. { id, name, dbname }
  save_tag: async data =>
    axios.get(baseUrl, {
      params: {
        method: 'save_tag',
        token: getToken(),
        ...data,
      },
    }),
  // Delete a tag (cascades to job/passenger/driver/vehicle tags). { id, dbname }
  delete_tag: async data =>
    axios.get(baseUrl, {
      params: {
        method: 'delete_tag',
        token: getToken(),
        ...data,
      },
    }),
};
